module.exports = "../../static/img/404.4bccd5f.png";